import { useState } from 'react';
import { IonModal, IonButton, IonIcon, IonSegment, IonSegmentButton, IonLabel } from '@ionic/react';
import { close } from 'ionicons/icons';
import './HotelSort.css';
import sortImg from '../../../assets/images/filter-sort.svg';


interface Props {
    hotelSortParentCallback: Function,
    disabled?: boolean
}
const HotelSort = (props: Props) => {
    const [state, setState] = useState({
        showHotelSortModal: false,
        sortPriceValue: 'priceAsc',
        sortRateValue: ''
    });
    const hotelSortParentCallback = () => {
        let hotelSortParentCallbackValue = state.sortPriceValue ? state.sortPriceValue : state.sortRateValue;
        props.hotelSortParentCallback(hotelSortParentCallbackValue);
    }
    const onConfirmModal = () => {
        hotelSortParentCallback();
        setState({ ...state, showHotelSortModal: false });
    }
    return (
        <>
            <IonModal isOpen={state.showHotelSortModal} onDidDismiss={() => setState({ ...state, showHotelSortModal: false })} mode="ios" cssClass="hotel-sort-modal">
                <div>
                    <h3 className="hotel-sort-modal-title">
                        مرتب سازی نتایج
                        <IonIcon icon={close} onClick={() => setState({ ...state, showHotelSortModal: false })} />
                    </h3>
                    <div className="hotel-sort-modal-items ion-text-center ion-margin-top">
                        <span className="hotel-sort-modal-items-title">مرتب سازی بر اساس قیمت</span>
                        <IonSegment onIonChange={e => setState({ ...state, sortPriceValue: e.detail.value!, sortRateValue: '' })} value={state.sortPriceValue}>
                            <IonSegmentButton value="priceAsc">
                                <IonLabel>صعودی</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton value="priceDesc">
                                <IonLabel>نزولی</IonLabel>
                            </IonSegmentButton>
                        </IonSegment>
                        <span className="hotel-sort-modal-items-title">مرتب سازی بر اساس ستاره هتل</span>
                        <IonSegment onIonChange={e => setState({ ...state, sortRateValue: e.detail.value!, sortPriceValue: '' })} value={state.sortRateValue}>
                            <IonSegmentButton value="rateAsc">
                                <IonLabel>صعودی</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton value="rateDesc">
                                <IonLabel>نزولی</IonLabel>
                            </IonSegmentButton>
                        </IonSegment>
                    </div>
                </div>
                <div className="hotel-sort-modal-footer-btns">
                    <IonButton color="primary" onClick={onConfirmModal} className="hotel-sort-modal-confirm-btn">تایید</IonButton>
                    <IonButton color="warning" onClick={() => setState({ ...state, showHotelSortModal: false })} className="hotel-sort-modal-close-btn">بستن</IonButton>
                </div>
            </IonModal>
            <span onClick={() => setState({ ...state, showHotelSortModal: true })} className={props.disabled ? 'disabled' : ''}>
                <IonIcon icon={sortImg} />
                ترتیب
            </span>
        </>
    );
};
export default HotelSort;